import { RefreshTokenOutDto, RefreshTokenInDto } from "../../types/auth.dto";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_ERROR = "REFRESH_TOKEN_ERROR";
export const RESET_REFRESH_TOKEN = "RESET_REFRESH_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const SET_INACTIVITY_MODAL = "SET_INACTIVITY_MODAL";
export const REFRESH_TOKEN_EXPIRATION_CHECK = 'REFRESH_TOKEN_EXPIRATION_CHECK';

export interface RefreshToken {
  type: typeof REFRESH_TOKEN;
  payload: {
    token: string,
    callback?: () => void,
  }
}

export interface RefreshTokenSuccess {
  type: typeof REFRESH_TOKEN_SUCCESS;
  payload: RefreshTokenInDto;
}

export interface RefreshTokenError {
  type: typeof REFRESH_TOKEN_ERROR;
  payload: string | boolean;
}

export interface ResetRefreshToken {
  type: typeof RESET_REFRESH_TOKEN;
  payload: null;
}

export interface SetToken {
  type: typeof SET_TOKEN;
  payload: RefreshTokenOutDto;
}

export interface Logout {
  type: typeof LOGOUT;
  payload: null;
}

interface RefreshTokenExpirationCheck {
  type: typeof REFRESH_TOKEN_EXPIRATION_CHECK;
}

export const logout = () => ({
  type: LOGOUT,
});

export interface State {
  data: RefreshTokenInDto | null | RefreshTokenOutDto ;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | RefreshToken
  | RefreshTokenSuccess
  | RefreshTokenError
  | ResetRefreshToken
  | SetToken
  | RefreshTokenExpirationCheck
  | Logout;
